<div class="main-content table-page table-page--compact table-page--dense sol">
  <div class="container-fluid">

    <!-- ==================== Pestañas ====================
         Vacaciones y permisos son dos cosas distintas que se piden en
         el mismo sitio. El permiso NO toca el saldo de vacaciones ni
         el calendario: vive en su propia tabla y en su propio
         componente, que es lo que garantiza que agregarlo no pudiera
         romper nada de lo que ya funcionaba. -->
    <div class="sol-pest" [class.sol-pest--tres]="esLider">
      <button type="button" class="sol-pest__btn"
              [class.is-activa]="pestana === 'vacaciones'"
              (click)="aVacaciones()">
        <span class="material-icons" aria-hidden="true">beach_access</span>
        Vacaciones
      </button>
      <button type="button" class="sol-pest__btn"
              [class.is-activa]="pestana === 'permisos'"
              (click)="pestana = 'permisos'">
        <span class="material-icons" aria-hidden="true">assignment_turned_in</span>
        Permisos
      </button>
      <!-- Sólo para quien autoriza: lo que espera su respuesta y el
           calendario de su gente, con la cuenta de lo pendiente. -->
      <button type="button" class="sol-pest__btn" *ngIf="esLider"
              [class.is-activa]="pestana === 'equipo'"
              (click)="aEquipo()">
        <span class="material-icons" aria-hidden="true">groups</span>
        Mi equipo
        <span class="sol-pest__cuenta" *ngIf="pendientesEquipo"
              [attr.aria-label]="pendientesEquipo + ' esperan tu respuesta'">{{ pendientesEquipo }}</span>
      </button>
    </div>

    <ng-container *ngIf="pestana === 'vacaciones'">

    <!-- ==================== Encabezado ====================
         Título con su frase DEBAJO. Es el ÚNICO encabezado de la
         pantalla. Desde el 30/09/2026 va solo, a todo lo ancho: debajo
         empiezan parejas las dos columnas. -->
    <section class="table-page__hero sol-hero">
      <!-- El icono a la izquierda y, a su lado, el título con la frase
           debajo, alineados (25/09/2026: «que se vea elegante»). -->
      <div class="table-page__copy sol-hero__copy">
        <span class="material-icons sol-hero__icono" aria-hidden="true">beach_access</span>
        <div class="sol-hero__textos">
          <h1>Mis vacaciones</h1>
          <p>Pide tus días y sigue aquí cómo van.</p>
        </div>
      </div>
    </section>

    <!-- Lo que espera la respuesta de quien autoriza y el calendario de su
         equipo viven desde el 30/09/2026 en su propia pestaña, «Mi
         equipo» (ver abajo): arriba y abajo del asistente hacían rodar la
         pantalla de los líderes. -->

    <!-- ==================== Lo de arriba ====================
         30/09/2026 (Norman: «como wizard ... evitar tanto espacio en
         blanco»): pedir es un asistente de tres pasos con el calendario a
         la vista, y a su lado, en ancho, el saldo y «Tus vacaciones»: a la
         izquierda lo que se hace y a la derecha cómo va. En angosto se
         apila: saldo, asistente y tus vacaciones (el orden lo pone el CSS).
         Las piezas del asistente y el acomodo son los de
         ../asistente-comun.css, los mismos de la pestaña Permisos. -->
    <div class="asi-inicio">
    <div class="asi-inicio__rejilla sol-rejilla">

      <!-- ==================== Pedir: el asistente ====================
           Tres pasos, como el de Mantenimiento: arriba los pasos (se puede
           volver a uno anterior tocándolo), en medio el paso y abajo los
           botones. -->
      <section class="table-page__card asi-wiz" aria-labelledby="solWizTit">
        <header class="asi-wiz__cab">
          <h2 id="solWizTit" class="asi-wiz__tit">Pedir vacaciones</h2>

          <ol class="asi-pasos" aria-label="Pasos para pedir vacaciones">
            <li *ngFor="let p of PASOS; let i = index"
                class="asi-pasos__paso"
                [class.es-actual]="i === indicePaso"
                [class.es-hecho]="i < indicePaso">
              <button type="button" class="asi-pasos__btn"
                      [disabled]="!puedeIrA(i)" (click)="irAPaso(i)"
                      [attr.aria-current]="i === indicePaso ? 'step' : null">
                <span class="asi-pasos__num" aria-hidden="true">
                  <span class="material-icons" *ngIf="i < indicePaso; else numero">check</span>
                  <ng-template #numero>{{ i + 1 }}</ng-template>
                </span>
                <span class="asi-pasos__txt">{{ p.texto }}</span>
              </button>
            </li>
          </ol>
        </header>

        <!-- Primera carga: los festivos y el último día que se puede pedir
             llegan con ella, y sin ellos el calendario dejaría escoger
             días que no se pueden. -->
        <div class="asi-wiz__cuerpo asi-wiz__carga" *ngIf="!yaCargo">
          <span class="material-icons" aria-hidden="true">hourglass_top</span>
          Consultando…
        </div>

        <!-- ========== 1. Fechas ==========
             Dos meses a la vista, el de hoy y el que sigue, que se
             recorren juntos (13/10/2026, Norman: «que al lado otro mes; así
             tenemos dos meses para ver y pedir»). Arriba, cómo se eligen:
             días seguidos (primer y último día, lo de siempre) o días
             sueltos («ejemplo el 15 y otro día el 20, solo esos dos»).
             Debajo —o al lado, si el asistente es ancho— lo elegido y lo
             que resulta. En angosto sólo cabe un mes. -->
        <div class="asi-wiz__cuerpo sol-fechas" *ngIf="yaCargo && paso === 'fechas'">

          <div class="sol-fechas__barra">
            <fieldset class="sol-modo">
              <legend class="cdk-visually-hidden">Cómo quieres elegir tus días</legend>
              <button type="button" class="sol-modo__op" *ngFor="let m of MODOS"
                      [class.es-activo]="modo === m.id"
                      [attr.aria-pressed]="modo === m.id"
                      [matTooltip]="m.ayuda" matTooltipClass="sol-tip"
                      (click)="cambiaModo(m.id)">
                <span class="material-icons" aria-hidden="true">{{ m.icono }}</span>
                {{ m.texto }}
              </button>
            </fieldset>

            <!-- La leyenda. «Hoy» regresa el calendario al mes de hoy
                 (30/09/2026, Norman: «si le doy click que me regrese a
                 hoy»), p. ej. después de ir a ver un festivo. -->
            <ul class="asi-leyenda sol-fechas__leyenda">
              <li *ngIf="!proximosFestivos.length">
                <span class="asi-leyenda__m asi-leyenda__m--festivo" aria-hidden="true"></span>Día festivo
              </li>
              <li *ngIf="hayPedidosAdelante">
                <span class="asi-leyenda__m sol-leyenda__mia" aria-hidden="true"></span>Ya pedido
              </li>
              <li>
                <button type="button" class="asi-hoy" (click)="verMes(hoy)"
                        matTooltip="Volver al mes de hoy" matTooltipClass="sol-tip">
                  <span class="asi-leyenda__m asi-leyenda__m--hoy" aria-hidden="true"></span>Hoy
                </button>
              </li>
              <li class="asi-leyenda__nota sol-fechas__regla">Fin de semana y festivos no cuentan.</li>
            </ul>
          </div>

          <!-- Los nombres de los meses y las flechas los pone esta pantalla:
               la cabecera de cada calendario de Material va oculta, porque
               cada una movería sólo su mes. -->
          <div class="sol-meses">
            <div class="sol-meses__cab">
              <button type="button" class="sol-meses__ir" [disabled]="!puedeRetroceder"
                      (click)="mueveMes(-1)" aria-label="Mes anterior">
                <span class="material-icons" aria-hidden="true">chevron_left</span>
              </button>
              <span class="sol-meses__tit" aria-live="polite">{{ tituloMes(mesIzq) }}</span>
              <span class="sol-meses__tit sol-meses__tit--der">{{ tituloMes(mesDer) }}</span>
              <button type="button" class="sol-meses__ir" [disabled]="!puedeAvanzar"
                      (click)="mueveMes(1)" aria-label="Mes siguiente">
                <span class="material-icons" aria-hidden="true">chevron_right</span>
              </button>
            </div>

            <div class="sol-meses__par">
              <mat-calendar #calIzq class="asi-cal sol-mes"
                            [selected]="modo === 'seguidos' ? rango : null"
                            (selectedChange)="eligeDia($event, calIzq)"
                            [startAt]="mesIzq"
                            [minDate]="hoy"
                            [maxDate]="maximo"
                            [dateFilter]="sePuedePedir"
                            [dateClass]="claseDia"
                            [comparisonStart]="previaDesde"
                            [comparisonEnd]="previaHasta"
                            startDateAccessibleName="Primer día"
                            endDateAccessibleName="Último día"></mat-calendar>
              <mat-calendar #calDer class="asi-cal sol-mes sol-mes--der"
                            [selected]="modo === 'seguidos' ? rango : null"
                            (selectedChange)="eligeDia($event, calDer)"
                            [startAt]="mesDer"
                            [minDate]="hoy"
                            [maxDate]="maximo"
                            [dateFilter]="sePuedePedir"
                            [dateClass]="claseDia"
                            [comparisonStart]="previaDesde"
                            [comparisonEnd]="previaHasta"
                            startDateAccessibleName="Primer día"
                            endDateAccessibleName="Último día"></mat-calendar>
            </div>
          </div>

          <div class="sol-fechas__lado">
            <div class="sol-elegido">
              <!-- Días seguidos: las dos puntas. La que toca elegir se marca
                   con el acento. -->
              <div class="asi-puntas" *ngIf="modo === 'seguidos'">
                <div class="asi-punta"
                     [class.es-espera]="!desde"
                     [class.es-lista]="!!desde">
                  <span class="asi-punta__et">Primer día</span>
                  <span class="asi-punta__val" *ngIf="desde; else sinPrimero">{{ diaCorto(desde) }}</span>
                  <ng-template #sinPrimero>
                    <span class="asi-punta__val asi-punta__val--falta">Por elegir</span>
                  </ng-template>
                </div>
                <span class="material-icons asi-puntas__flecha" aria-hidden="true">arrow_forward</span>
                <div class="asi-punta"
                     [class.es-espera]="!!desde && !hasta"
                     [class.es-lista]="!!hasta">
                  <span class="asi-punta__et">Último día</span>
                  <span class="asi-punta__val" *ngIf="hasta; else sinUltimo">{{ diaCorto(hasta) }}</span>
                  <ng-template #sinUltimo>
                    <span class="asi-punta__val asi-punta__val--falta">{{ desde ? 'Por elegir' : '—' }}</span>
                  </ng-template>
                </div>
              </div>

              <!-- Días sueltos: una ficha por tramo, con su × para quitarlo.
                   Los días pegados salen juntos («lun 19 – mar 20 oct»):
                   se piden en una sola solicitud. -->
              <div class="asi-punta sol-sueltos" *ngIf="modo === 'sueltos'"
                   [class.es-espera]="!tramos.length">
                <span class="asi-punta__et sol-sueltos__tit">
                  <span id="solSueltosTit">Días elegidos</span>
                  <span class="sol-sueltos__mas" *ngIf="tramos.length > tramosALaVista.length">
                    y {{ tramos.length - tramosALaVista.length }} más
                  </span>
                </span>
                <ul class="sol-sueltos__lista" aria-labelledby="solSueltosTit" aria-live="polite"
                    *ngIf="tramos.length; else sinSueltos">
                  <li class="sol-suelto" *ngFor="let t of tramosALaVista">
                    <span>{{ tramoCorto(t) }}</span>
                    <button type="button" class="sol-suelto__x" (click)="quitaTramo(t)"
                            [attr.aria-label]="'Quitar ' + tramoCorto(t)">
                      <span class="material-icons" aria-hidden="true">close</span>
                    </button>
                  </li>
                </ul>
                <ng-template #sinSueltos>
                  <span class="asi-punta__val asi-punta__val--falta">Por elegir</span>
                </ng-template>
              </div>
            </div>

            <div class="sol-resultado" [class.con-resultado]="tramos.length > 0">
              <!-- Qué sigue, en palabras, va al pie junto a «Siguiente»
                   (asi-wiz__guia). -->
              <ng-container *ngIf="tramos.length">
                <!-- Fechas que el calendario no habría dejado elegir (ver
                     avisoFechas). Va primero y sola: con esas fechas no hay
                     periodo del cual hablar. -->
                <div class="sol-cuenta sol-cuenta--alerta" *ngIf="avisoFechas">
                  <span class="material-icons">event_busy</span>
                  <span>{{ avisoFechas }} Ajusta las fechas.</span>
                </div>

                <!-- La cuenta va contra el periodo que contiene el PRIMER día
                     de cada tramo, que no siempre es el de la tarjeta del
                     saldo: quien pide para después de su aniversario pide
                     contra su periodo siguiente. Por eso se dice cuál es. -->
                <div class="sol-cuenta sol-cuenta--alerta" *ngIf="seExcede && !avisoFechas">
                  <span class="material-icons">error_outline</span>
                  <span *ngIf="excedido as e; else dejaNegativo">
                    Estás pidiendo <b>{{ e.pide }}</b>
                    {{ e.pide === 1 ? 'día' : 'días' }} y
                    <ng-container *ngIf="textoPeriodo(e.periodo)">
                      de tu periodo <b>{{ textoPeriodo(e.periodo) }}</b>
                    </ng-container>
                    <ng-container *ngIf="e.tiene !== null && e.tiene > 0; else yaNoQuedan">
                      solo te quedan <b>{{ e.tiene }}</b>.
                    </ng-container>
                    <ng-template #yaNoQuedan>ya no te quedan días.</ng-template>
                    Ajusta las fechas.
                  </span>
                  <!-- Le alcanza en este periodo, pero lo que no use se acumula
                       al siguiente, y ahí ya pidió contando con eso: quedaría en
                       negativo. El servidor lo rechazaría después de la firma. -->
                  <ng-template #dejaNegativo>
                    <span>
                      Lo que no uses de tu periodo <b>{{ textoPeriodo(saldoPedido) }}</b>
                      se acumula al siguiente, y en tu periodo
                      <b>{{ textoPeriodo(siguienteEnNegativo) }}</b> ya tienes días
                      pedidos: con estas fechas quedaría en <b>{{ quedariaSiguiente }}</b>.
                      Ajusta las fechas o retira alguna solicitud de ese periodo.
                    </span>
                  </ng-template>
                </div>

                <!-- Lo que le quedaría va dentro de la cuenta, «de» lo que tiene.
                     Desde el 20/10/2026 dice de dónde salen los días («lo que le
                     sobra primero», ver fuentes): lo que pide para su siguiente
                     periodo sale primero de lo que le sobra al vigente, que es
                     el «te quedan» de la derecha. Si sale de otro periodo, o de
                     varios, dice de cuál. Con varios tramos, en vez del regreso
                     se dice que van juntos en una solicitud. -->
                <div class="asi-conteo" *ngIf="diasPedidos > 0 && !seExcede && !avisoFechas">
                  <span class="asi-conteo__num">{{ diasPedidos }}</span>
                  <span class="asi-conteo__txt">
                    <b>{{ diasPedidos === 1 ? 'día hábil' : 'días hábiles' }}</b>
                    <span *ngIf="unico; else enVarias">Regresas el {{ textoRegreso }}</span>
                    <ng-template #enVarias>
                      <span>En una sola solicitud, con {{ tramos.length }} tramos.</span>
                    </ng-template>
                    <span *ngIf="cuentasConSaldo.length"><ng-container
                      *ngFor="let c of cuentasConSaldo; let primero = first; let ultimo = last">{{ primero ? 'Te quedarían' : ' y'
                      }} <strong>{{ c.quedarian }}</strong> de {{ c.tiene }}{{ etiquetaFuente(c) }}{{ ultimo ? '.' : '' }}</ng-container></span>
                  </span>
                </div>

                <!-- Las fechas llegan a su siguiente periodo: no se reparten
                     entre los dos, se descuentan completas del periodo en que
                     empiezan (así lo cuenta el servidor). -->
                <div class="sol-cruce" *ngIf="diasPedidos > 0 && cruzaPeriodo && !avisoFechas">
                  <span class="material-icons">info_outline</span>
                  <span>
                    Tus fechas llegan a tu siguiente periodo, que empieza el
                    <b>{{ corta(saldoPedido?.periodoFin) }}</b>. Aun así se descuentan
                    completas de tu periodo <b>{{ textoPeriodo(saldoPedido) }}</b>,
                    que es en el que empiezan.
                  </span>
                </div>
              </ng-container>

              <!-- Los próximos festivos, que son a la vez la leyenda del
                   fucsia del calendario: tocar uno trae su mes a la vista,
                   para ver los puentes. Cada uno con su hojita (mes y día),
                   el día de la semana, cuánto falta y si hace fin de semana
                   largo. Con lo elegido debajo de los meses, ocupan el
                   lugar de la cuenta mientras no hay nada elegido; con lo
                   elegido al lado, se quedan (cuatro, o dos con la cuenta:
                   festivosVisibles). -->
              <div class="sol-proximos" *ngIf="proximosFestivos.length">
                <span class="sol-proximos__tit" id="solProximosTit">Próximos festivos</span>
                <ul class="sol-proximos__lista" aria-labelledby="solProximosTit">
                  <li *ngFor="let f of festivosVisibles">
                    <button type="button" class="sol-proximo"
                            [attr.aria-label]="f.texto + ', ' + f.falta + (f.largo ? ', fin de semana largo' : '') + ': verlo en el calendario'"
                            (click)="verMes(f.fecha)">
                      <span class="sol-proximo__hoja" aria-hidden="true">
                        <span class="sol-proximo__mes">{{ f.mes }}</span>
                        <span class="sol-proximo__num">{{ f.dia }}</span>
                      </span>
                      <span class="sol-proximo__txt">
                        <span class="sol-proximo__dia">{{ f.semana }}<ng-container *ngIf="f.anio"> · {{ f.anio }}</ng-container></span>
                        <span class="sol-proximo__falta">
                          {{ f.falta }}<span class="sol-proximo__largo" *ngIf="f.largo"> · fin de semana largo</span>
                        </span>
                      </span>
                      <span class="material-icons sol-proximo__ir" aria-hidden="true">chevron_right</span>
                    </button>
                  </li>
                </ul>
              </div>

              <!-- La regla del calendario: aquí cuando lo elegido va al
                   lado; si va debajo, junto a la leyenda de arriba. -->
              <p class="sol-fechas__regla sol-fechas__regla--lado">Fin de semana y festivos no cuentan.</p>
            </div>
          </div>
        </div>

        <!-- ========== 2. Revisa (y 3. mientras firma) ==========
             Sustituye al «¿Pedir estas vacaciones?» de antes: lo mismo que
             decía la confirmación, a la vista y sin ventana encima. La firma
             se abre en su ventana de siempre; mientras, esto se queda debajo
             y los pasos marcan el tercero. -->
        <div class="asi-wiz__cuerpo asi-rev"
             *ngIf="yaCargo && (paso === 'revisa' || paso === 'firma') && tramos.length">
          <!-- Un tramo: de qué día a qué día, y cuándo regresa. -->
          <ng-container *ngIf="unico as t; else variosTramos">
            <div class="asi-rev__viaje" [class.es-un-dia]="unSoloDia">
              <span class="cdk-visually-hidden">{{ rangoLargo(t.desde, t.hasta) }}</span>
              <div class="asi-hoja" aria-hidden="true">
                <span class="asi-hoja__mes">
                  {{ mesDe(t.desde) }}<small *ngIf="anioSiOtro(t.desde)"> {{ anioSiOtro(t.desde) }}</small>
                </span>
                <span class="asi-hoja__dia">{{ t.desde.getDate() }}</span>
                <span class="asi-hoja__sem">{{ semanaDe(t.desde) }}</span>
              </div>

              <div class="asi-rev__tramo">
                <span class="asi-rev__cuantos">
                  <b>{{ diasPedidos }}</b> {{ diasPedidos === 1 ? 'día hábil' : 'días hábiles' }}
                </span>
                <span class="asi-rev__linea" aria-hidden="true" *ngIf="!unSoloDia"></span>
              </div>

              <div class="asi-hoja" aria-hidden="true" *ngIf="!unSoloDia">
                <span class="asi-hoja__mes">
                  {{ mesDe(t.hasta) }}<small *ngIf="anioSiOtro(t.hasta)"> {{ anioSiOtro(t.hasta) }}</small>
                </span>
                <span class="asi-hoja__dia">{{ t.hasta.getDate() }}</span>
                <span class="asi-hoja__sem">{{ semanaDe(t.hasta) }}</span>
              </div>
            </div>

            <p class="asi-rev__regreso">
              <span class="material-icons" aria-hidden="true">keyboard_return</span>
              <span>Regresas el <b>{{ textoRegreso }}</b></span>
            </p>
          </ng-container>

          <!-- Días sueltos en varios tramos: van juntos, en una solicitud. -->
          <ng-template #variosTramos>
            <p class="sol-rev-varios">
              <b>{{ diasPedidos }}</b> días hábiles en <b>{{ tramos.length }}</b> tramos, una sola solicitud
            </p>
            <ol class="sol-rev-tramos" aria-label="Lo que vas a pedir">
              <li class="sol-rev-tramo" *ngFor="let t of tramos">
                <span class="sol-proximo__hoja sol-rev-tramo__hoja" aria-hidden="true">
                  <span class="sol-proximo__mes">{{ mesDe(t.desde) }}</span>
                  <span class="sol-proximo__num">{{ t.desde.getDate() }}</span>
                </span>
                <span class="sol-rev-tramo__txt">
                  <b>{{ tramoCorto(t) }}</b>
                  <span>{{ t.dias }} {{ t.dias === 1 ? 'día hábil' : 'días hábiles' }}</span>
                </span>
              </li>
            </ol>
          </ng-template>

          <!-- De qué periodo salen los días («lo que le sobra primero») y
               cuánto le quedaría: dos fichas por cada uno (casi siempre, uno).
               Si salen de lo que le sobra a un periodo que no es el de las
               fechas, la ficha lo dice («De lo que te sobra»). Ver fuentes y
               fichasRevisa. -->
          <dl class="asi-rev__datos">
            <div class="asi-rev__dato" *ngFor="let f of fichasRevisa">
              <dt>{{ etiquetaFicha(f) }}</dt>
              <dd *ngIf="!f.quedan">{{ textoPeriodo(f.cuenta.periodo) }}</dd>
              <dd *ngIf="f.quedan">
                <span class="asi-rev__cifra"><b>{{ f.cuenta.quedarian }}</b> de {{ f.cuenta.tiene }}</span>
                <span class="asi-barra" aria-hidden="true">
                  <span class="asi-barra__pide" [style.width.%]="parteDe(f.cuenta)"></span>
                </span>
                <small class="asi-rev__nota" *ngIf="f.conPeriodo">{{ notaFicha(f.cuenta) }}</small>
              </dd>
            </div>
            <div class="asi-rev__dato" *ngIf="autorizadorHoy">
              <dt>La autoriza</dt>
              <dd>
                {{ autorizadorHoy }}
                <small class="asi-rev__nota" *ngIf="ausenciaAutorizador">{{ ausenciaAutorizador }}</small>
              </dd>
            </div>
          </dl>

          <div class="sol-cruce" *ngIf="cruzaPeriodo">
            <span class="material-icons">info_outline</span>
            <span>
              Tus fechas llegan a tu siguiente periodo, que empieza el
              <b>{{ corta(saldoPedido?.periodoFin) }}</b>. Aun así se descuentan
              completas de tu periodo <b>{{ textoPeriodo(saldoPedido) }}</b>,
              que es en el que empiezan.
            </span>
          </div>

          <p class="asi-rev__firma">
            <span class="material-icons" aria-hidden="true">draw</span>
            <span *ngIf="unico; else firmaVarias">
              Al continuar firmas tu <b>FRC-019</b>: digital aquí mismo, o lo
              descargas para firmarlo a mano. Después se envía a autorización.
            </span>
            <ng-template #firmaVarias>
              <span>
                Firmas una sola vez y se envía una solicitud con todos los
                tramos y un solo <b>FRC-019</b> (digital, o lo descargas para
                firmarlo a mano). Se autoriza completa.
              </span>
            </ng-template>
          </p>
        </div>

        <!-- ========== Listo ==========
             En vez del «quedó registrada» en una ventana: el asistente lo
             dice en su lugar y la solicitud aparece resaltada en «Tus
             vacaciones». -->
        <div class="asi-wiz__cuerpo asi-listo" *ngIf="paso === 'listo' && enviada" role="status">
          <span class="asi-listo__ok" aria-hidden="true">
            <span class="material-icons">check</span>
          </span>
          <h3 class="asi-listo__tit">
            ¡Listo! Tu solicitud va en camino
          </h3>
          <p class="asi-listo__que">
            Pediste <b>{{ enviada.rango }}</b>:
            {{ enviada.dias }} {{ enviada.dias === 1 ? 'día hábil' : 'días hábiles' }}.
          </p>
          <p class="asi-listo__quien">
            <ng-container *ngIf="enviada.autoriza; else sinQuien">
              Le llegó a <b>{{ enviada.autoriza }}</b> para autorizarla.
            </ng-container>
            <ng-template #sinQuien>
              Le llegó a quien autoriza tus vacaciones.
            </ng-template>
            Te avisamos aquí cuando la resuelva.
          </p>
          <!-- «Descargar para firmar»: el FRC-019 ya se descargó (uno, aunque
               sean varios tramos), y el papel firmado se sube desde la
               solicitud (ver app-frc-firmado). -->
          <p class="asi-listo__papel" *ngIf="enviada.papel">
            <span class="material-icons" aria-hidden="true">description</span>
            <span>
              Se descargó tu FRC-019. Fírmalo a mano y súbelo desde tu solicitud
              en «Tus vacaciones», con «Subir firmado».
            </span>
          </p>
        </div>

        <footer class="asi-wiz__pie" *ngIf="yaCargo">
          <ng-container *ngIf="paso === 'fechas'">
            <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                    *ngIf="desde || sueltos.size" (click)="limpiaFechas()">
              <span class="material-icons" aria-hidden="true">restart_alt</span>
              Limpiar fechas
            </button>
            <!-- Qué sigue, en palabras: con días seguidos, mientras falta
                 una punta; con días sueltos, siempre (se puede seguir
                 agregando o quitando). -->
            <span class="asi-wiz__guia" *ngIf="modo === 'seguidos' && !hasta" aria-live="polite">
              <span class="material-icons" aria-hidden="true">touch_app</span>
              <span *ngIf="!desde"><b>Toca en el calendario tu primer día.</b></span>
              <span *ngIf="desde"><b>Ahora toca tu último día.</b> Si es uno solo, tócalo otra vez.</span>
            </span>
            <span class="asi-wiz__guia" *ngIf="modo === 'sueltos'" aria-live="polite">
              <span class="material-icons" aria-hidden="true">touch_app</span>
              <span *ngIf="topeTramos; else guiaSueltos">
                <b>Hasta {{ MAX_TRAMOS }} tramos por solicitud.</b> Envía estos y pide después los demás.
              </span>
              <ng-template #guiaSueltos>
                <span *ngIf="!sueltos.size"><b>Toca cada día que quieres.</b> Los que queden pegados se piden juntos.</span>
                <span *ngIf="sueltos.size"><b>Toca otro día para agregarlo</b>, o uno elegido para quitarlo.</span>
              </ng-template>
            </span>
            <span class="asi-wiz__hueco"></span>
            <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                    [disabled]="!puedeEnviar" (click)="aRevisar()">
              Siguiente
              <span class="material-icons" aria-hidden="true">arrow_forward</span>
            </button>
          </ng-container>

          <ng-container *ngIf="paso === 'revisa' || paso === 'firma'">
            <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                    [disabled]="paso !== 'revisa'" (click)="aFechas()">
              <span class="material-icons" aria-hidden="true">arrow_back</span>
              Cambiar fechas
            </button>
            <span class="asi-wiz__hueco"></span>
            <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                    [disabled]="paso !== 'revisa'" (click)="firmarYEnviar()">
              <span class="material-icons" aria-hidden="true">{{ enviando ? 'hourglass_top' : 'draw' }}</span>
              {{ enviando ? 'Enviando…' : 'Firmar y enviar' }}
            </button>
          </ng-container>

          <ng-container *ngIf="paso === 'listo'">
            <span class="asi-wiz__hueco"></span>
            <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                    (click)="otraSolicitud()">
              <span class="material-icons" aria-hidden="true">add</span>
              Pedir otras fechas
            </button>
          </ng-container>
        </footer>
      </section>

      <!-- ==================== Al lado: el saldo y tus vacaciones ==================== -->
      <div class="asi-lado" *ngIf="yaCargo">

        <!-- El saldo: desde el 24/09/2026 su PERIODO de aniversario, con las
             mismas columnas que la hoja de RH: días de goce − gozados =
             restantes, más lo acumulado de periodos anteriores = lo que le
             queda. Los números los manda hechos el servidor. -->
        <div class="sol-saldo" [class.es-pendiente]="diasTotales === null">
          <ng-container *ngIf="diasTotales !== null; else sinAsignar">
            <!-- Como «Inicio» y «Fin del periodo» del Excel: el fin es el
                 aniversario siguiente. -->
            <div class="sol-saldo__periodo" *ngIf="textoPeriodo(saldo)">
              <span class="material-icons">event</span>
              <span>Tu periodo: <b>{{ textoPeriodo(saldo) }}</b></span>
            </div>

            <div class="sol-saldo__cuenta">
              <div class="sol-saldo__dato"
                   [matTooltip]="tipGoce" matTooltipClass="sol-tip">
                <span class="sol-saldo__num">{{ diasTotales }}</span>
                <span class="sol-saldo__et">días de goce</span>
              </div>
              <span class="sol-saldo__op">&minus;</span>
              <!-- Con días cargados del Excel de RH el número es mayor que
                   lo que se ve abajo en la lista de periodos: el tooltip
                   dice de dónde sale cada parte. -->
              <div class="sol-saldo__dato"
                   [matTooltip]="desgloseUsados" matTooltipClass="sol-tip">
                <span class="sol-saldo__num">{{ diasUsados }}</span>
                <span class="sol-saldo__et">gozados</span>
              </div>
              <span class="sol-saldo__op">=</span>
              <!-- «gozados» es la etiqueta del Excel de RH, pero cuenta
                   también lo que espera respuesta: la ayuda lo dice. -->
              <div class="sol-saldo__dato"
                   matTooltip="Días de goce menos lo que ya usaste o tienes apartado de ellos (autorizado o en espera). Lo que pides para tu siguiente periodo sale primero de lo que te sobra aquí."
                   matTooltipClass="sol-tip">
                <span class="sol-saldo__num">{{ restantes }}</span>
                <span class="sol-saldo__et">restantes</span>
              </div>
              <!-- Lo que sobró de periodos anteriores. Va con su signo y
                   no detrás de un "+", porque puede ser negativo (quien
                   tomó de más antes). Suma a lo que puede tomar pero no a
                   la prima; sin él, la cuenta no cuadraría con el número
                   de la derecha. -->
              <div class="sol-saldo__dato sol-saldo__dato--extra"
                   [matTooltip]="tipAcumulado" matTooltipClass="sol-tip">
                <span class="sol-saldo__num">{{ acumuladoConSigno }}</span>
                <span class="sol-saldo__et">acumulado</span>
              </div>
              <span class="sol-saldo__op">=</span>
              <div class="sol-saldo__dato sol-saldo__dato--fuerte"
                   [class.es-poco]="disponibles !== null && disponibles <= 2"
                   [matTooltip]="desgloseQuedan" matTooltipClass="sol-tip">
                <span class="sol-saldo__num">{{ disponibles }}</span>
                <span class="sol-saldo__et">te quedan</span>
              </div>
            </div>

            <div class="sol-saldo__notas" *ngIf="periodoCalendario || notaSiguiente">
              <p *ngIf="periodoCalendario">
                Tu periodo es el año calendario porque RH aún no captura tu
                fecha de ingreso.
              </p>
              <p *ngIf="notaSiguiente">{{ notaSiguiente }}</p>
            </div>
          </ng-container>

          <ng-template #sinAsignar>
            <div class="sol-saldo__aviso"
                 matTooltip="Pregunta con quien administra el calendario"
                 matTooltipClass="sol-tip">
              <span class="material-icons">info_outline</span>
              Sin días asignados
            </div>
          </ng-template>
        </div>

        <!-- ==================== TUS VACACIONES ====================
             Una sola lista, con las que esperan respuesta arriba. El estado
             se lee por el color de la barra: ámbar espera, verde autorizada,
             rojo no autorizada. Sin año en el título: trae también las que
             ya pidió para el año que entra. Desde el 30/09/2026 junto al
             asistente: lo que se acaba de pedir aparece aquí, resaltado.

             Y ese mismo día (Norman: «no quiero scroll ... paginado o
             diferente»): por páginas de las que caben, con el paginado en
             el encabezado, y cada una en su renglón con las acciones en
             íconos, como en «Tus permisos». Antes cada tarjeta se desplegaba
             con sus botones y tres de ellas ya no cabían junto al asistente.
             Con filtro por estado: la cuenta de «En espera» sustituye a la
             pastilla «N en espera» que llevaba el título. -->
        <section class="table-page__card sol-bloque sol-mias">
          <div class="sol-mias__cab">
            <h2 class="sol-bloque__tit">Tus vacaciones</h2>
            <nav class="asi-pagina" *ngIf="totalPaginasMias > 1" aria-label="Páginas de tus vacaciones">
              <button type="button" class="table-page__pager-link"
                      [disabled]="paginaMiasNorm <= 1" (click)="mueveMias(-1)"
                      title="Página anterior" aria-label="Página anterior">
                <span class="material-icons">chevron_left</span>
              </button>
              <span class="asi-pagina__txt">{{ paginaMiasNorm }} de {{ totalPaginasMias }}</span>
              <button type="button" class="table-page__pager-link"
                      [disabled]="paginaMiasNorm >= totalPaginasMias" (click)="mueveMias(1)"
                      title="Página siguiente" aria-label="Página siguiente">
                <span class="material-icons">chevron_right</span>
              </button>
            </nav>
          </div>

          <!-- El filtro, del color de cada estado y con cuántas hay. Se
               prende y se apaga; puesto, su cuenta se vuelve una × al
               pasar encima. Uno sin ninguna no se puede escoger. -->
          <div class="asi-filtros" role="group" aria-label="Filtrar tus vacaciones por estado"
               *ngIf="misPeriodos.length">
            <button type="button" class="asi-filtro" *ngFor="let f of FILTROS_MIAS"
                    [ngClass]="f.clase"
                    [class.es-activo]="filtroMias === f.id"
                    [attr.aria-pressed]="filtroMias === f.id"
                    [disabled]="!cuantasMias(f.id) && filtroMias !== f.id"
                    [matTooltip]="filtroMias === f.id ? 'Quitar el filtro' : ''"
                    matTooltipClass="sol-tip"
                    (click)="filtraMias(f.id)">
              {{ f.texto }}
              <span class="asi-filtro__n">
                <span class="asi-filtro__num">{{ cuantasMias(f.id) }}</span>
                <span class="material-icons asi-filtro__x" aria-hidden="true">close</span>
              </span>
            </button>
          </div>

          <div class="sol-tarjetas" #listaMias *ngIf="misPeriodos.length; else sinVacaciones">
            <div class="sol-tarjeta" [ngClass]="clase(v)"
                 [class.es-nueva]="esNueva(v)"
                 *ngFor="let v of misPeriodosPagina; trackBy: trackVacacion">
              <div class="sol-tarjeta__barra"></div>
              <div class="sol-tarjeta__cuerpo">
                <div class="sol-tarjeta__cab">
                  <span class="sol-tarjeta__rango">{{ textoRango(v) }}</span>
                  <span class="sol-tarjeta__dias">
                    {{ diasDe(v) }} {{ diasDe(v) === 1 ? 'día' : 'días' }}
                  </span>
                  <!-- El estado, con quién la resolvió y, si se firmó en
                       papel, si ya se subió el FRC-019 firmado o si falta. -->
                  <span class="sol-tarjeta__estado">
                    <span class="material-icons" aria-hidden="true">{{ icono(v) }}</span>
                    {{ etiqueta(v) }}
                    <span class="sol-tarjeta__quien" *ngIf="v.autorizaNombre">
                      · {{ v.autorizaNombre }}
                    </span>
                    <span class="sol-tarjeta__papel" *ngIf="tieneFrc(v) && v.enPapel"
                          [class.es-listo]="!!v.firmado?.idFirmado">
                      · {{ v.firmado?.idFirmado ? 'FRC-019 firmado subido' : 'Falta subir el FRC-019 firmado' }}
                    </span>
                  </span>

                  <!-- Las acciones en íconos, como en toda tabla del estándar
                       y en «Tus permisos»: retirar (sólo mientras nadie la
                       resuelve), el FRC-019 firmado a mano (subir o ver) y el
                       FRC-019. El documento vive mientras la solicitud viva:
                       de una negada no hay; su evidencia es el rechazo. -->
                  <div class="table-page__action-group sol-tarjeta__acciones">
                    <button type="button" class="table-page__action-btn table-page__action-btn--danger"
                            *ngIf="v.estatus === 'PENDIENTE'"
                            [disabled]="retirando === v.idVacacion"
                            matTooltip="Retirar la solicitud" matTooltipClass="sol-tip"
                            aria-label="Retirar la solicitud"
                            (click)="retirar(v)">
                      <span class="material-icons">{{ retirando === v.idVacacion ? 'hourglass_top' : 'undo' }}</span>
                    </button>
                    <app-frc-firmado *ngIf="tieneFrc(v)"
                                     variante="icono"
                                     tipo="VACACION"
                                     [id]="v.idVacacion"
                                     [enPapel]="!!v.enPapel"
                                     [firmado]="v.firmado"
                                     (cambio)="v.firmado = $event"></app-frc-firmado>
                    <button type="button" class="table-page__action-btn"
                            *ngIf="tieneFrc(v)"
                            [disabled]="generandoFrc === v.idVacacion"
                            matTooltip="Bajar el FRC-019" matTooltipClass="sol-tip"
                            aria-label="Bajar el FRC-019"
                            (click)="frcDe(v)">
                      <span class="material-icons">{{ generandoFrc === v.idVacacion ? 'hourglass_top' : 'description' }}</span>
                    </button>
                  </div>
                </div>

                <!-- El motivo del rechazo es lo primero que va a buscar. En
                     una línea, como la nota, para que todas las tarjetas
                     midan parecido; entero, al pasar encima. -->
                <div class="sol-tarjeta__motivo" *ngIf="v.motivo && v.estatus === 'RECHAZADA'"
                     [attr.title]="v.motivo">
                  <span class="material-icons">chat_bubble_outline</span>
                  <span class="sol-tarjeta__motivo-txt">{{ v.motivo }}</span>
                </div>
                <div class="sol-tarjeta__nota" *ngIf="nota(v)" [attr.title]="nota(v)">{{ nota(v) }}</div>
              </div>
            </div>
          </div>

          <!-- Vacío del estándar, dentro de su tarjeta. -->
          <ng-template #sinVacaciones>
            <div class="table-page__empty sol-mias__vacio">
              <span class="material-icons">beach_access</span>
              <h3>Todavía no has pedido vacaciones este año.</h3>
              <p>Cuando pidas, aquí verás si ya te las autorizaron.</p>
            </div>
          </ng-template>
        </section>
      </div>

    </div>
    </div>

    </ng-container>

    <!-- ==================== MI EQUIPO ====================
         Sólo para quien autoriza (o a quien hoy le toca resolver algo por
         suplencia). Desde el 30/09/2026 (Norman: «déjalo súper acomodado»)
         en su propia pestaña: lo que espera su respuesta estaba arriba del
         asistente y el calendario del equipo debajo, y a los líderes les
         rodaba la pantalla. Aquí, lado a lado: a la izquierda lo que hay que
         responder y a la derecha quién más va a estar fuera, que es con lo
         que se decide. En angosto, uno bajo otro. -->
    <ng-container *ngIf="pestana === 'equipo'">

    <!-- Responder un permiso —la confirmación con el goce, la firma del
         FRC-017, resolver y bajar el FRC-017— es de app-permisos: aquí no
         dibuja nada, sólo presta ese flujo a los renglones de la bandeja
         (29/10/2026), como en «Autorizaciones» del calendario. -->
    <app-permisos #accionesPermiso vista="resolver" (resuelto)="alResolverPermiso()"></app-permisos>

    <section class="table-page__hero sol-hero">
      <div class="table-page__copy sol-hero__copy">
        <span class="material-icons sol-hero__icono" aria-hidden="true">groups</span>
        <div class="sol-hero__textos">
          <h1>Mi equipo</h1>
          <p>Lo que espera tu respuesta y quién va a estar fuera.</p>
        </div>
      </div>
    </section>

    <div class="asi-inicio">
    <div class="sol-equipo-tab" [class.sol-equipo-tab--solo]="!esAutorizador">

      <!-- ==================== Esperan tu respuesta ====================
           Una tarjeta con las dos bandejas, vacaciones y permisos, cada una
           con su cuenta; se ve una a la vez para que cada lista tenga todo
           el alto de la columna, y va por páginas de las que caben. El
           ámbar es el de siempre: «pide atención» sin gritar. -->
      <section class="table-page__card sol-resolver sol-espera" aria-labelledby="solEsperaTit">
        <!-- El paginado es uno solo, a la derecha del título: el de la
             bandeja que se está viendo. -->
        <div class="sol-espera__cab">
          <h2 id="solEsperaTit" class="sol-resolver__cab">
            <span class="material-icons" aria-hidden="true">notifications_active</span>
            Esperan tu respuesta
          </h2>
          <nav class="asi-pagina" aria-label="Páginas de lo que espera tu respuesta"
               *ngIf="paginasEspera.total > 1">
            <button type="button" class="table-page__pager-link"
                    [disabled]="paginasEspera.actual <= 1" (click)="mueveEspera(-1)"
                    title="Página anterior" aria-label="Página anterior">
              <span class="material-icons">chevron_left</span>
            </button>
            <span class="asi-pagina__txt">{{ paginasEspera.actual }} de {{ paginasEspera.total }}</span>
            <button type="button" class="table-page__pager-link"
                    [disabled]="paginasEspera.actual >= paginasEspera.total" (click)="mueveEspera(1)"
                    title="Página siguiente" aria-label="Página siguiente">
              <span class="material-icons">chevron_right</span>
            </button>
          </nav>
        </div>

        <div class="asi-filtros sol-espera__vistas" role="tablist" aria-label="Qué solicitudes ver">
          <button type="button" role="tab" class="asi-filtro asi-filtro--espera"
                  [class.es-activo]="vistaResolver === 'vacaciones'"
                  [attr.aria-selected]="vistaResolver === 'vacaciones'"
                  (click)="eligeVistaResolver('vacaciones')">
            <span class="material-icons" aria-hidden="true">beach_access</span>
            Vacaciones
            <span class="asi-filtro__n">{{ porResolver.length }}</span>
          </button>
          <button type="button" role="tab" class="asi-filtro asi-filtro--espera"
                  [class.es-activo]="vistaResolver === 'permisos'"
                  [attr.aria-selected]="vistaResolver === 'permisos'"
                  (click)="eligeVistaResolver('permisos')">
            <span class="material-icons" aria-hidden="true">assignment_turned_in</span>
            Permisos
            <span class="asi-filtro__n">{{ permisosPendientes }}</span>
          </button>
        </div>

        <!-- Las vacaciones que esperan. La barrita va en su color, o en el
             azul de siempre si no trae (las pedidas no traen): sin él no se
             veía (29/10/2026). -->
        <div role="tabpanel" *ngIf="vistaResolver === 'vacaciones'">
          <div class="sol-resolver__lista" #listaResolver *ngIf="porResolver.length; else sinVacPendientes">
            <div class="sol-solicitud" *ngFor="let v of porResolverPagina; trackBy: trackVacacion">
              <span class="sol-solicitud__color" [style.background]="tinte(v.color, 1)"></span>

              <div class="sol-solicitud__texto">
                <span class="sol-solicitud__nombre">{{ v.colaborador }}</span>
                <span class="sol-solicitud__rango">{{ textoRango(v) }}</span>
                <span class="sol-solicitud__nota" *ngIf="nota(v)" [attr.title]="nota(v)">{{ nota(v) }}</span>
                <!-- Le llega por suplencia: se dice de quién es y por qué,
                     para que no la resuelva creyendo que es de su gente. -->
                <span class="sol-solicitud__suplencia" *ngIf="v.suplenteDe">
                  <span class="material-icons">swap_vert</span>
                  Te llega a ti: {{ v.suplenteDe }} está {{ v.ausencia }}
                </span>
                <!-- Le llega porque nadie más puede: el colaborador no tiene
                     autorizador en su saldo. Es lo único ajeno que ve quien
                     administra el calendario desde el 14/09. -->
                <span class="sol-solicitud__suplencia" *ngIf="v.sinAutorizador">
                  <span class="material-icons">person_off</span>
                  Te llega a ti: no tiene autorizador asignado
                </span>
              </div>

              <span class="sol-solicitud__dias">
                {{ diasDe(v) }} {{ diasDe(v) === 1 ? 'día' : 'días' }}
              </span>

              <div class="sol-solicitud__acciones">
                <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                        *ngIf="v.tieneFirma"
                        matTooltip="El FRC-019 firmado por quien pide"
                        [disabled]="generandoFrc === v.idVacacion"
                        (click)="frcDe(v)">
                  <span class="material-icons">description</span>
                  FRC-019
                </button>
                <!-- Si quien pide lo firmó en papel y ya lo subió, se ve aquí.
                     Subirlo es de su tarjeta, no de la bandeja. -->
                <app-frc-firmado *ngIf="v.tieneFirma"
                                 tipo="VACACION"
                                 [id]="v.idVacacion"
                                 [enPapel]="!!v.enPapel"
                                 [firmado]="v.firmado"
                                 [puedeSubir]="false"></app-frc-firmado>
                <!-- Juntos y a la derecha: si con el FRC firmado a mano ya
                     no caben en el renglón, bajan los dos y siguen ahí. -->
                <span class="sol-solicitud__decide">
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                          [disabled]="resolviendo === v.idVacacion"
                          (click)="rechazar(v)">
                    <span class="material-icons">close</span>
                    No
                  </button>
                  <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                          [disabled]="resolviendo === v.idVacacion"
                          (click)="autorizar(v)">
                    <span class="material-icons">check</span>
                    Autorizar
                  </button>
                </span>
              </div>
            </div>
          </div>
          <ng-template #sinVacPendientes>
            <p class="sol-espera__vacio">
              <span class="material-icons" aria-hidden="true">task_alt</span>
              Ninguna solicitud de vacaciones espera tu respuesta.
            </p>
          </ng-template>
        </div>

        <!-- Los permisos que esperan, desde el 29/10/2026 con el renglón y
             el paginado de las vacaciones (Norman: «no en una ventana sino
             que salga como el de vacaciones»): la barrita en el color de su
             tipo, qué y cuándo, la hora (o el día completo) donde las
             vacaciones dicen los días, y al pie el FRC-017, «No» y
             «Autorizar». Se responden con accionesPermiso, arriba. -->
        <div role="tabpanel" *ngIf="vistaResolver === 'permisos'">
          <div class="sol-resolver__lista" #listaResolver *ngIf="permisosPorResolver.length; else sinPerPendientes">
            <div class="sol-solicitud" *ngFor="let f of permisosPagina; trackBy: trackPermiso">
              <span class="sol-solicitud__color" [ngClass]="f.clase"></span>

              <div class="sol-solicitud__texto">
                <span class="sol-solicitud__nombre">{{ f.permiso.colaborador }}</span>
                <span class="sol-solicitud__rango">{{ f.que }}</span>
                <span class="sol-solicitud__nota" *ngIf="f.nota" [attr.title]="f.nota">{{ f.nota }}</span>
                <span class="sol-solicitud__suplencia" *ngIf="f.permiso.suplenteDe">
                  <span class="material-icons">swap_vert</span>
                  Te llega a ti: {{ f.permiso.suplenteDe }} está {{ f.permiso.ausencia }}
                </span>
                <span class="sol-solicitud__suplencia" *ngIf="f.permiso.sinAutorizador">
                  <span class="material-icons">person_off</span>
                  Te llega a ti: no tiene autorizador asignado
                </span>
              </div>

              <span class="sol-solicitud__dias sol-solicitud__dias--hora">
                <span class="material-icons" aria-hidden="true">{{ f.icono }}</span>
                {{ f.horas }}
              </span>

              <div class="sol-solicitud__acciones">
                <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                        *ngIf="f.permiso.tieneFirma"
                        matTooltip="El FRC-017 firmado por quien pide"
                        [disabled]="accionesPermiso.generandoFrc === f.permiso.idPermiso"
                        (click)="accionesPermiso.frcDe(f.permiso)">
                  <span class="material-icons">description</span>
                  FRC-017
                </button>
                <app-frc-firmado *ngIf="f.permiso.tieneFirma"
                                 tipo="PERMISO"
                                 [id]="f.permiso.idPermiso"
                                 [enPapel]="!!f.permiso.enPapel"
                                 [firmado]="f.permiso.firmado"
                                 [puedeSubir]="false"></app-frc-firmado>
                <span class="sol-solicitud__decide">
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                          [disabled]="accionesPermiso.resolviendo === f.permiso.idPermiso"
                          (click)="accionesPermiso.rechazar(f.permiso)">
                    <span class="material-icons">close</span>
                    No
                  </button>
                  <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact"
                          [disabled]="accionesPermiso.resolviendo === f.permiso.idPermiso"
                          (click)="accionesPermiso.autorizar(f.permiso)">
                    <span class="material-icons">check</span>
                    Autorizar
                  </button>
                </span>
              </div>
            </div>
          </div>
          <ng-template #sinPerPendientes>
            <p class="sol-espera__vacio">
              <span class="material-icons" aria-hidden="true">task_alt</span>
              Ningún permiso espera tu respuesta.
            </p>
          </ng-template>
        </div>
      </section>

    <!-- ==================== EL EQUIPO ====================
         Solo su gente, no toda la empresa: lo que necesita para decidir
         es saber quién más va a estar fuera esos días. La rejilla del
         calendario (sol-tabla-caja / sol-cal) es la de siempre; desde el
         29/10/2026 cada día trae también los permisos de su gente
         (Norman: «también permisos aparezcan en el calendario»). -->
    <section class="table-page__card sol-bloque sol-equipo" *ngIf="esAutorizador">
      <div class="sol-equipo__cab">
        <h2 class="sol-bloque__tit">Tu equipo</h2>

        <div class="sol-anio sol-anio--mes">
          <button type="button" class="sol-anio__btn" (click)="mueveMesEquipo(-1)"
                  matTooltip="Mes anterior" matTooltipClass="sol-tip">
            <span class="material-icons">chevron_left</span>
          </button>
          <span class="sol-anio__txt sol-anio__txt--mes">{{ tituloMesEquipo }}</span>
          <button type="button" class="sol-anio__btn" (click)="mueveMesEquipo(1)"
                  matTooltip="Mes siguiente" matTooltipClass="sol-tip">
            <span class="material-icons">chevron_right</span>
          </button>
        </div>
      </div>

      <div class="sol-tabla-caja">
        <table class="sol-cal">
          <thead>
            <!-- Sólo de lunes a viernes: el fin de semana no se trabaja. -->
            <tr>
              <th *ngFor="let d of encabezadosCal">{{ d }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let semana of semanasEquipo">
              <td *ngFor="let dia of semana"
                  class="sol-cal__dia"
                  [class.es-hoy]="dia.esHoy"
                  [class.es-vacia]="!dia.numero">
                <span class="sol-cal__num" *ngIf="dia.numero">{{ dia.numero }}</span>

                <!-- El color del colaborador va en --sol-tag y no directo
                     en color: el CSS lo mezcla con la tinta para que el
                     nombre se lea también en Oscuro (24/09/2026). El borde
                     de la que espera sale de tinte(), con el azul de
                     siempre si no trae color: sin él el punteado no se
                     veía (29/10/2026). -->
                <span class="sol-cal__tag" *ngFor="let v of dia.periodos"
                      [class.es-pendiente]="v.estatus === 'PENDIENTE'"
                      [style.background]="tinte(v.color, 0.14)"
                      [style.borderColor]="tinte(v.color, v.estatus === 'PENDIENTE' ? 1 : 0.34)"
                      [style.--sol-tag]="v.color"
                      [matTooltip]="tipVacacion(v)"
                      matTooltipClass="sol-tip">
                  {{ v.colaborador }}
                </span>

                <!-- Los permisos de su gente (29/10/2026): un punto en un
                     día, no una franja, así que van como en Seguimiento: en
                     neutro, con el icono de su tipo, el nombre corto y la
                     hora si no es el día entero; el que espera, punteado. -->
                <span class="sol-cal__per" *ngFor="let f of dia.permisos"
                      [class.es-pendiente]="f.pendiente"
                      [matTooltip]="f.tip" matTooltipClass="sol-tip">
                  <span class="material-icons" aria-hidden="true">{{ f.icono }}</span>
                  <span class="sol-cal__quien">{{ f.corto }}</span>
                  <span class="sol-cal__hora" *ngIf="f.hora">{{ f.hora }}</span>
                </span>

                <!-- Dos renglones por día: si hay más, el resto va aquí y en
                     su globo, uno por renglón (sin esto la semana crecía y
                     la página rodaba). -->
                <span class="sol-cal__mas" *ngIf="dia.mas"
                      [matTooltip]="dia.masTip" matTooltipClass="sol-tip sol-tip--lista">
                  +{{ dia.mas }} más
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Una sola línea de ayuda: la rejilla ya es de lunes a viernes.
           Desde el 29/10/2026 también dice cómo se ve un permiso. -->
      <p class="sol-equipo__pie">
        El borde punteado es lo que todavía no has resuelto; los permisos llevan el icono de su tipo.
      </p>
    </section>

    </div>
    </div>

    </ng-container>

    <!-- El permiso, en su propio componente: aquí sólo lo propio (el
         asistente y «Tus permisos»); lo que espera respuesta va en «Mi
         equipo». -->
    <app-permisos *ngIf="pestana === 'permisos'" vista="pedir"
                  (pendientes)="alCambiarPermisos($event)"></app-permisos>

  </div>
</div>

<!-- ==================== FIRMA DEL FRC-019 ==================== -->
<app-firma-frc
  *ngIf="firmaAbierta"
  [para]="firmaPara"
  [nombre]="firmaObjetivo?.colaborador"
  (firmada)="firmada($event)"
  (cancelada)="cancelaFirma()"
></app-firma-frc>
